import { config } from '../config';
import { UNKNOWN_TEAM } from './constants';
const transformTeam = (team, id) => {
  return {
    id,
    name: team.displayName,
    type: 'team',
    avatarUrl: team.smallAvatarImageUrl
  };
};
const hydrateTeamFromLegion = request => {
  const url = `${config.getTeamsUrl(request.baseUrl)}/${request.id}`;
  return fetch(url, {
    method: 'GET',
    credentials: 'include',
    headers: {
      'content-type': 'application/json'
    }
  }).then(response => {
    if (response.status === 200) {
      return response.json();
    }
    return Promise.reject({
      message: `error calling Legion, statusCode=${response.status}, statusText=${response.statusText}`
    });
  }).then(response => {
    return transformTeam(response, request.id);
  }).catch(() => ({
    ...UNKNOWN_TEAM,
    // on network error, return original team with label 'Unknown'
    id: request.id
  }));
};
export default hydrateTeamFromLegion;